var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"XyscoShVZPnfJwcUCe0QG"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";
import {
  shouldIgnoreException,
  shouldIgnoreByMessage,
} from "./sentry-ignore-rules";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,

  tracesSampleRate: 0.0,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,

  beforeSend(event) {
    const exception = event.exception?.values?.[0];
    const message = exception?.value;
    const requestUrl = event.request?.url;

    // Ignore known message-only errors
    if (shouldIgnoreByMessage(message)) {
      return null;
    }

    // Ignore structured exception rules
    if (shouldIgnoreException(exception, requestUrl)) {
      return null;
    }

    return event;
  },

  beforeBreadcrumb(breadcrumb) {
    if (
      (breadcrumb.category === "csp" && breadcrumb.type === "error") ||
      breadcrumb.category === "xhr"
    ) {
      return null;
    }

    return breadcrumb;
  },
});

Sentry.setTag("env", process.env.NEXT_PUBLIC_SENTRY_ENV);
